import Layout from '../../components/Layout';

function Admin() {
    return (
        <Layout>
            <main className="container py-5">
                <section className="card border-0 shadow-sm" style={{ background: 'linear-gradient(180deg, #f8f1e5, #efe1c6)' }}>
                    <div className="card-body p-4 p-lg-5">
                        <p className="text-uppercase fw-semibold mb-2" style={{ letterSpacing: '0.18em', color: '#86613a' }}>Admin area</p>
                        <h1 className="display-6 mb-3">Reserved for future tools</h1>
                        <p className="lead mb-0">
                            This route is kept for authenticated admin access, but it does not power any site features yet.
                        </p>
                    </div>
                </section>
            </main>
        </Layout>
    );
}

export default Admin;